
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var container = function container(_ref) {
  var fullScreen = _ref.fullScreen;
  return /*#__PURE__*/ /*#__PURE__*/css("display:flex;justify-content:center;align-items:center;width:100%;height:", fullScreen ? "100vh" : "auto", ";.loader-wrapper{display:block!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:container;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkYiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBTZXJpYWxpemVkU3R5bGVzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0XCI7XG5cbmV4cG9ydCBjb25zdCBjb250YWluZXIgPSAoeyBmdWxsU2NyZWVuIH06IHsgZnVsbFNjcmVlbjogYm9vbGVhbiB9KTogU2VyaWFsaXplZFN0eWxlcyA9PiBjc3NgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICB3aWR0aDogMTAwJTtcbiAgaGVpZ2h0OiAke2Z1bGxTY3JlZW4gPyBcIjEwMHZoXCIgOiBcImF1dG9cIn07XG5cbiAgLmxvYWRlci13cmFwcGVyIHtcbiAgICBkaXNwbGF5OiBibG9jayAhaW1wb3J0YW50O1xuICB9XG5gO1xuIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:container;");
};

export { container };
//# sourceMappingURL=styles.js.map
